import type Capability from "../schema/Capability";
import type { MailboxInfo } from "owa-client-types";

/** Indicates if the capability can be enabled ("supported") and is enabled */
export function isCapabilityEnabled(capability: Capability, mailboxInfo?: MailboxInfo): boolean {
    const isSupported = capability.isSupported(mailboxInfo);
    
    return isSupported && capability.isEnabled(mailboxInfo);
}

/** Indicates if the capability can be enabled */
export function isCapabilitySupported(capability: Capability, mailboxInfo?: MailboxInfo): boolean {
    return capability.isSupported(mailboxInfo);
}
